export class ProductBaseOptionModel {
    public variantType: string;
}